import { render } from "./TableLiteTs.vue?vue&type=template&id=fa6de276&scoped=true&ts=true"
import script from "./TableLiteTs.vue?vue&type=script&lang=ts"
export * from "./TableLiteTs.vue?vue&type=script&lang=ts"

import "./TableLiteTs.vue?vue&type=style&index=0&id=fa6de276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa6de276"]])

export default __exports__